import { isEmpty } from 'lodash';
import apiClient from '../../services/api-client';
import { TYPES } from '@/views/client-connect-v2/constants.js';
import { UPDATE_CONTACTS } from './constants/contacts.js';
import clientConnectService from '@/services/toolbox/client-connect-service';
import { VIEWS as MODAL_VIEWS } from '@/views/client-connect-v2/modals/constants.js';
import leadsService from '@/services/contacts/leads-service.js';
import alertsService from '@/services/contacts/alerts-service.js';
import loansService from '@/services/contacts/loans-service.js';

const state = {
	leads: {
		onInit: true,
		error: false,
		items: [],
		index: {},
		totalCount: null,
		initialTotalCount: 0,
		types: {
			type: TYPES.CONTACT,
			data: [],
		},
		listWithDetails: [],
		states: [],
		creditWatchList: [],
		leadIdClicked: null,
		selectedLeadIds: [],
		contactUpdateType: UPDATE_CONTACTS.NO_ACTION,
	},
	blink: {
		leadInfo: {
			firstName: null,
			lastName: null,
			email: null,
		},
		blinkUnregistered: false,
		sendContactToBlink: false,
	},
	filters: {
		typesIds: [],
		loanTypeIds: [],
		loanPurposeIds: [],
		searchTerm: '',
	},
	loans: {
		listWithDetails: [],
		dropDownOptions: null,
		filterOptions: {
			loanTypes: [],
			loanPurposeTypes: [],
		},
	},
	loanDetails: {
		view: 'Details',
	},
	views: {
		showOverviewModal: false,
		sort: false,
		sortColumn: 'lastName',
		sortDirection: 'asc',
		modalView: '',
		showMultipleContactsImportModal: false,
		removeModalBackCaret: false,
		modalHistory: [],
		modalPreference: null,
		pageSize: 20,
		selectAllMode: false,
		currentPageContacts: [],
		loading: false,
	},
};

const mutations = {
	RESET_CLIENT_CONNECT_LEADS(state) {
		state.leads.onInit = true;
		state.leads.items = [];
		state.leads.selectedLeadIds = [];
		state.filters.typesIds = [];
		state.filters.loanTypeIds = [];
		state.filters.loanPurposeIds = [];
		state.filters.searchTerm = '';
	},
	// leads
	SET_LEADS_ONINIT(state, payload) {
		state.leads.onInit = payload;
	},
	SET_LEADS_ERROR(state, payload) {
		state.leads.error = payload;
	},
	GET_ALL_LEAD_TYPES_SUCCESS(state, payload) {
		state.leads.types.data = [...payload];
	},
	RESET_LEADS_LIST_WITH_DETAILS(state) {
		state.leads.listWithDetails = [];
	},
	UPDATE_LEAD_ON_LEADS_LIST_WITH_DETAILS(state, payload) {
		const currentLead = state.leads.listWithDetails.find(
			(user) => user.leadId === payload.leadId,
		);
		const remainingLeads = state.leads.listWithDetails.filter(
			(user) => user.leadId !== payload.leadId,
		);
		const updatedLead = currentLead ? { ...currentLead, ...payload } : payload;
		state.leads.listWithDetails = [...remainingLeads, updatedLead];
	},
	GET_LEAD_SUCCESS(state, payload) {
		state.leads.listWithDetails = [...state.leads.listWithDetails, payload];
	},
	APPEND_CONTACTS_SUCCESS(state, payload) {
		if (payload.pageNumber === 1) {
			state.leads.items = [...payload.items];
		} else {
			state.leads.items = [...state.leads.items, ...payload.items];
		}

		state.leads.totalCount = payload.totalCount;
		state.leads.onInit = false;
	},
	REFRESH_CONTACTS_SUCCESS(state, payload) {
		state.leads.items = [...payload.items];
		state.leads.totalCount = payload.totalCount;
		if (state.leads.initialTotalCount < payload.totalCount) {
			state.leads.initialTotalCount = payload.totalCount;
		}
	},
	REPLACE_CONTACTS_SUCCESS(
		state,
		{ payload, firstSliceEnd, secondSliceStart },
	) {
		state.leads.items = [
			...state.leads.items.slice(0, firstSliceEnd),
			...payload.items,
			...state.leads.items.slice(secondSliceStart),
		];
		state.leads.totalCount = payload.totalCount;
	},
	CREATE_INDEX(state) {
		state.leads.index = state.leads.items.reduce(
			(accumulator, contact, index) => {
				return {
					...accumulator,
					[contact.leadId]: index,
				};
			},
			{},
		);
	},
	UPDATE_INDEX(state, payload) {
		const length = Object.keys(state.leads.index).length;
		let index = payload.items.reduce((accumulator, contact, index) => {
			return {
				...accumulator,
				[contact.leadId]: index + length,
			};
		}, {});
		state.leads.index = {
			...state.leads.index,
			...index,
		};
	},
	GET_ALL_STATES_SUCCESS(state, payload) {
		state.leads.states = [...payload];
	},
	GET_ACTIVITIES_SUCCESS(state, payload) {
		const currentContact = state.leads.listWithDetails.find(
			(user) => user.leadId === payload[0].leadId,
		);
		const remainingContacts = state.leads.listWithDetails.filter(
			(user) => user.leadId !== payload[0].leadId,
		);
		currentContact.activities = [...payload];
		state.leads.listWithDetails = [...remainingContacts, currentContact];
	},
	GET_CREDIT_WATCH_LIST(state, payload) {
		state.leads.creditWatchList = [...payload];
	},
	CLEAR_LEADS(state) {
		state.leads.items = [];
	},
	SET_LEAD_ID_CLICKED(state, payload) {
		state.leads.leadIdClicked = payload;
	},
	SET_SELECTED_LEAD_IDS(state, payload) {
		state.leads.selectedLeadIds = payload;
	},
	CONTACT_UPDATE_TYPE(state, payload) {
		state.leads.contactUpdateType = payload;
	},
	EDIT_CONTACT_PROPERTY(state, { leadIds, prop, value, selectAll }) {
		let leadsToUpdate = leadIds;
		if (selectAll) {
			leadsToUpdate = state.leads.items
				.map((contact) => contact.leadId)
				.filter((id) => !leadIds.includes(id));
		}
		for (const id of leadsToUpdate) {
			state.leads.items[state.leads.index[id]][prop] = value;
		}
		state.views.showOverviewModal = false;
		state.leads.leadIdClicked = null;
	},
	EDIT_SINGLE_CONTACT(state, { id, ...updatedContact }) {
		state.leads.items[state.leads.index[id]] = {
			...state.leads.items[state.leads.index[id]],
			...updatedContact,
		};
	},
	REMOVE_CONTACTS(state, { leadIds, selectAll }) {
		let contacts = state.leads.items;
		let leadsToUpdate = leadIds;
		if (selectAll) {
			leadsToUpdate = state.leads.items
				.map((contact) => contact.leadId)
				.filter((id) => !leadIds.includes(id));
		}
		contacts = contacts.filter(
			(contact) => !leadsToUpdate.includes(contact.leadId),
		);
		state.leads.items = contacts;
		state.leads.totalCount = state.leads.totalCount - leadsToUpdate.length;
		state.leads.initialTotalCount =
			state.leads.initialTotalCount - leadsToUpdate.length;
	},
	//blink
	SET_LEAD_INFO(state, lead) {
		state.blink.leadInfo.firstName = lead.firstName;
		state.blink.leadInfo.lastName = lead.lastName;
		state.blink.leadInfo.email = lead.email;
	},
	SET_BLINK_UNREGISTERED(state, payload) {
		state.blink.blinkUnregistered = payload;
	},
	SET_SEND_CONTACT_TO_BLINK(state, payload) {
		state.blink.sendContactToBlink = payload;
	},
	// filters
	UPDATE_FILTERS_TYPESIDS(state, payload) {
		state.filters.typesIds = [...payload];
	},
	UPDATE_FILTERS_LOANTYPEIDS(state, payload) {
		state.filters.loanTypeIds = [...payload];
	},
	UPDATE_FILTERS_LOANPURPOSEIDS(state, payload) {
		state.filters.loanPurposeIds = [...payload];
	},
	UPDATE_FILTERS_SEARCHTERM(state, payload) {
		state.filters.searchTerm = payload;
	},
	// lead alerts
	GET_LEAD_ALERTS(state, payload) {
		const alerts = {
			alerts: payload.data,
			alertsTotalCount: payload.data.length,
		};
		const currentContact = state.leads.listWithDetails.find(
			(user) => user.leadId === payload.leadId,
		);
		const remainingContacts = state.leads.listWithDetails.filter(
			(user) => user.leadId !== payload.leadId,
		);
		if (!currentContact.hasOwnProperty('alerts') || payload.refreshList) {
			const currentUserWithAlerts = { ...currentContact, ...alerts };
			state.leads.listWithDetails = [
				...remainingContacts,
				currentUserWithAlerts,
			];
		}
	},
	// loans
	GET_LOAN_BY_ID_SUCCESS(state, payload) {
		state.loans.listWithDetails = [...state.loans.listWithDetails, payload];
	},
	SET_LOAN_DETAILS_VIEW(state, payload) {
		state.loanDetails.view = payload;
	},
	GET_ALL_LOAN_DROP_DOWN_OPTIONS_SUCCESS(state, payload) {
		state.loans.dropDownOptions = payload;
	},
	GET_LEADS_LOANS(state, payload) {
		state.loans.listWithDetails = payload;
	},
	GET_LOAN_TYPES(state, payload) {
		state.loans.filterOptions.loanTypes = payload;
	},
	GET_LOAN_PURPOSE_TYPES(state, payload) {
		state.loans.filterOptions.loanPurposeTypes = payload;
	},
	SET_LOAN_FILTERS(state, payload) {
		state.loans.filterOptions = payload;
	},
	// views
	SET_SHOW_OVERVIEW_MODAL(state, payload) {
		state.views.showOverviewModal = payload;
	},
	SET_SORT(state, payload) {
		state.views.sort = payload;
	},
	SET_SORT_COLUMN(state, payload) {
		state.views.sortColumn = payload;
	},
	SET_SORT_DIRECTION(state, payload) {
		state.views.sortDirection = payload;
	},
	SET_MODAL_VIEW(state, payload) {
		state.views.modalView = payload;
	},
	SET_SHOW_MULTIPLE_CONTACTS_IMPORT_MODAL(state, payload) {
		state.views.showMultipleContactsImportModal = payload;
	},
	SET_REMOVE_MODAL_BACK_CARET(state, payload) {
		state.views.removeModalBackCaret = payload;
	},
	SET_MODAL_HISTORY(state, payload) {
		state.views.modalHistory = payload;
	},
	SET_MODAL_PREFERENCE(state, payload) {
		state.views.modalPreference = payload;
	},
	SET_CCCONTACTS_PAGE_SIZE(state, payload) {
		state.views.pageSize = payload;
	},
	SET_SELECT_ALL_MODE(state, payload) {
		state.views.selectAllMode = payload;
	},
	SET_CURRENT_PAGE_CONTACTS(state, payload) {
		state.views.currentPageContacts = payload;
	},
	SET_CCCONTACTS_LOADING(state, payload) {
		state.views.loading = payload;
	},
};

const actions = {
	resetClientConnectLeads({ commit }) {
		commit('RESET_CLIENT_CONNECT_LEADS');
	},
	// leads
	setLeadsOninit({ commit }, payload) {
		commit('SET_LEADS_ONINIT', payload);
	},
	setLeadsError({ commit }, payload) {
		commit('SET_LEADS_ERROR', payload);
	},
	async getLeads(
		{ commit, dispatch, getters, rootState, state },
		{ activeInd = true, pageNumber = 1, pageSize = 20 },
	) {
		dispatch('setLeadsError', false);
		const { entityId, contactsIds } = getters.currentUserRolodexIds;
		const ids = [...new Set(contactsIds)]; // removes duplicate contactIds
		const selectedContactsIds = rootState.clientConnectV2.selectedContactsIds;
		const payloadContactsIds = isEmpty(selectedContactsIds)
			? ids
			: selectedContactsIds;
		const payload = {
			data: {
				entityId,
				contactsIds: payloadContactsIds,
				typesIds: state.filters.typesIds,
				loanTypeIds: state.filters.loanTypeIds,
				loanPurposeIds: state.filters.loanPurposeIds,
			},
			activeInd,
			searchTerm: state.filters.searchTerm,
			sortColumn: state.views.sortColumn,
			sortDirection: state.views.sortDirection,
			pageNumber,
			pageSize,
		};
		try {
			const response = await leadsService.getSearchLeads(payload);
			if (response) {
				switch (state.leads.contactUpdateType) {
					case UPDATE_CONTACTS.APPEND_CONTACTS:
						commit('APPEND_CONTACTS_SUCCESS', response);
						commit('UPDATE_INDEX', response);
						break;
					case UPDATE_CONTACTS.REFRESH_CONTACTS:
						commit('REFRESH_CONTACTS_SUCCESS', response);
						commit('CREATE_INDEX');
						break;
					case UPDATE_CONTACTS.REPLACE_CONTACTS: {
						const firstSliceEnd = pageSize * (pageNumber - 1);
						const secondSliceStart = pageSize * (pageNumber + 4);
						commit('REPLACE_CONTACTS_SUCCESS', {
							payload: response,
							firstSliceEnd,
							secondSliceStart,
						});
						commit('CREATE_INDEX');
						break;
					}
				}
				dispatch('setContactUpdateType', UPDATE_CONTACTS.NO_ACTION);
				dispatch('setCCContactsLoading', false);
			}
		} catch (error) {
			dispatch('setLeadsError', true);
			dispatch('setCCContactsLoading', false);
		} finally {
			dispatch('updateSelectedContactsIdsUpdated', false, { root: true });
		}
	},
	async getAllLeadTypes({ commit }) {
		if (state.leads.types.data.length > 0) return;
		try {
			const data = await leadsService.getAllLeadTypes();
			if (data) {
				commit('GET_ALL_LEAD_TYPES_SUCCESS', data);
			}
		} catch (error) {
			console.error('Failed to load lead types!');
		}
	},
	async getLeadDetailsById({ commit }, leadId) {
		try {
			const data = await leadsService.getLeadDetailsById(leadId);
			commit('GET_LEAD_SUCCESS', data);
			return Promise.resolve(data);
		} catch (error) {
			return Promise.resolve({
				error: 'there was an error',
			});
		}
	},
	async saveLeadDetails({ commit }, payload) {
		try {
			const data = await leadsService.saveLeadDetails(payload);
			/**
			 * The UI has and needs the "source" property in the payload
			 * but the backend doesn't use or return it. So here we add
			 * the value for source that we have.
			 */
			data.lead.source = payload.source;
			commit('UPDATE_LEAD_ON_LEADS_LIST_WITH_DETAILS', data.lead);
			return Promise.resolve(data);
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async transferLeads({ commit }, payload) {
		try {
			await leadsService.transferLeads(payload);
			commit('RESET_LEADS_LIST_WITH_DETAILS');
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getAllStates({ commit }) {
		try {
			const response = await leadsService.getAllStates();
			if (response) {
				commit('GET_ALL_STATES_SUCCESS', response);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getActivityLog({ commit }, leadId) {
		try {
			const response = await leadsService.getActivityLog(leadId);
			if (response) {
				if (!isEmpty(response)) {
					commit('GET_ACTIVITIES_SUCCESS', response);
				}
				return Promise.resolve(response);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getCreditWatchList({ commit }, payload) {
		try {
			const response = await leadsService.getCreditWatchList(payload);
			if (response) {
				commit('GET_CREDIT_WATCH_LIST', response);
				return Promise.resolve(response);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	clearLeads({ commit }) {
		commit('CLEAR_LEADS');
	},
	setLeadIdClicked({ commit }, payload) {
		commit('SET_LEAD_ID_CLICKED', payload);
	},
	handleAddSingleContact({ dispatch }) {
		dispatch('setLeadIdClicked', null);
		dispatch('setModalView', MODAL_VIEWS.ADD_CONTACT);
		dispatch('setShowOverviewModal', true);
	},
	async exportContacts({ getters, rootState }) {
		const { entityId, contactsIds } = getters.currentUserRolodexIds;
		const [organizationId] = rootState.profile.organizationId;
		const payload = {
			entityId,
			organizationId,
			contactsIds,
		};
		try {
			await leadsService.exportContacts(payload);
		} catch (error) {
			return Promise.reject(error);
		}
	},
	setSelectedLeadIds({ commit }, payload) {
		commit('SET_SELECTED_LEAD_IDS', payload);
	},
	setContactUpdateType({ commit }, payload) {
		commit('CONTACT_UPDATE_TYPE', payload);
	},
	editContactProperty({ commit }, payload) {
		commit('EDIT_CONTACT_PROPERTY', payload);
	},
	editSingleContact({ commit }, payload) {
		commit('EDIT_SINGLE_CONTACT', payload);
	},
	removeContacts({ commit }, contactIds) {
		commit('REMOVE_CONTACTS', contactIds);
		commit('CREATE_INDEX');
	},
	// blink
	setLeadInfo({ commit }, lead) {
		commit('SET_LEAD_INFO', lead);
	},
	setBlinkUnregistered({ commit }, payload) {
		commit('SET_BLINK_UNREGISTERED', payload);
	},
	setSendContactToBlink({ commit }, payload) {
		commit('SET_SEND_CONTACT_TO_BLINK', payload);
	},
	handleAddBlinkData({ dispatch, rootState }, lead) {
		dispatch('setLeadInfo', lead);
		if (
			rootState.companyProfile.blinkRegistrationInd &&
			rootState.profile.blinkRegistrationInd
		) {
			dispatch('setBlinkUnregistered', false);
		} else {
			dispatch('setBlinkUnregistered', true);
		}
		dispatch('setSendContactToBlink', true);
	},
	// filters
	updatefiltersTypesIds({ commit }, typesIds) {
		if (typesIds === undefined) {
			commit('UPDATE_FILTERS_TYPESIDS', []);
		} else {
			commit('UPDATE_FILTERS_TYPESIDS', typesIds);
		}
	},
	updatefiltersLoanTypeIds({ commit }, loanTypeIds) {
		if (loanTypeIds === undefined) {
			commit('UPDATE_FILTERS_LOANTYPEIDS', []);
		} else {
			commit('UPDATE_FILTERS_LOANTYPEIDS', loanTypeIds);
		}
	},
	updatefiltersLoanPurposeIds({ commit }, loanPurposeIds) {
		if (loanPurposeIds === undefined) {
			commit('UPDATE_FILTERS_LOANPURPOSEIDS', []);
		} else {
			commit('UPDATE_FILTERS_LOANPURPOSEIDS', loanPurposeIds);
		}
	},
	updatefiltersSearchTerm({ commit }, searchTerm) {
		commit('UPDATE_FILTERS_SEARCHTERM', searchTerm);
	},
	// lead alerts
	async getLeadAlerts({ commit }, payload) {
		try {
			const response = await alertsService.getLeadAlerts(payload);
			if (response) {
				commit('GET_LEAD_ALERTS', {
					data: response,
					leadId: payload.leadId,
					refreshList: payload.refreshList,
				});
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getEmailTemplatesByAlertTypeId({ commit }, typeId) {
		try {
			const response = await apiClient().get(
				`/Preference/GetEmailTemplatesByType?alertTypeId=${typeId}`,
			);
			if (response && response.data) {
				commit('GET_LOAN_BY_ID_SUCCESS', response.data);
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	// Loans
	async getLoanById({ commit }, loanId) {
		try {
			const response = await apiClient().get(`/Loan/GetLoan?loanId=${loanId}`);
			if (response && response.data) {
				commit('GET_LOAN_BY_ID_SUCCESS', response.data);
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getLeadLoansForId({ commit }, leadId) {
		try {
			const response = await loansService.getLeadLoansForId(leadId);
			if (response) {
				commit('GET_LEADS_LOANS', response);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	setLoanDetailsView({ commit }, view) {
		commit('SET_LOAN_DETAILS_VIEW', view);
	},
	async getGetAllLoanDropDownOptions({ commit }) {
		// get all the things
		try {
			const options = await clientConnectService.getLoanDropDownOptions();

			commit('GET_ALL_LOAN_DROP_DOWN_OPTIONS_SUCCESS', options);
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getLoanTypes({ commit }) {
		if (state.loans.filterOptions.loanTypes.length > 0) return;
		try {
			const data = await loansService.getAllLoanTypes();
			if (data) {
				commit('GET_LOAN_TYPES', data);
			}
		} catch (error) {
			console.error('Failed to load loan types!');
		}
	},
	async getLoanPurposeTypes({ commit }) {
		if (state.loans.filterOptions.loanPurposeTypes.length > 0) return;
		try {
			const data = await loansService.getAllLoanPurposeTypes();
			if (data) {
				commit('GET_LOAN_PURPOSE_TYPES', data);
			}
		} catch (error) {
			console.error('Failed to load loan Purpose types!');
		}
	},
	// views
	setShowOverviewModal({ commit }, payload) {
		commit('SET_SHOW_OVERVIEW_MODAL', payload);
	},
	setSort({ commit }, payload) {
		commit('SET_SORT', payload);
	},
	setSortColumn({ commit }, payload) {
		commit('SET_SORT_COLUMN', payload);
	},
	setSortDirection({ commit }, payload) {
		commit('SET_SORT_DIRECTION', payload);
	},
	setModalView({ commit }, payload) {
		commit('SET_MODAL_VIEW', payload);
	},
	setShowMultipleContactsImportModal({ commit }, payload) {
		commit('SET_SHOW_MULTIPLE_CONTACTS_IMPORT_MODAL', payload);
	},
	setRemoveModalBackCaret({ commit }, payload) {
		commit('SET_REMOVE_MODAL_BACK_CARET', payload);
	},
	setModalHistory({ commit }, payload) {
		commit('SET_MODAL_HISTORY', payload);
	},
	setModalPreference({ commit }, payload) {
		commit('SET_MODAL_PREFERENCE', payload);
	},
	setCCContactsPageSize({ commit }, payload) {
		commit('SET_CCCONTACTS_PAGE_SIZE', payload);
	},
	setSelectAllMode({ commit }, payload) {
		commit('SET_SELECT_ALL_MODE', payload);
	},
	setCurrentPageContacts({ commit }, payload) {
		commit('SET_CURRENT_PAGE_CONTACTS', payload);
	},
	setCCContactsLoading({ commit }, payload) {
		commit('SET_CCCONTACTS_LOADING', payload);
	},
};

const getters = {
	// used by ContactDetails, MultipleContactsImport, and UpdateContactType
	contactTypeOptions(state) {
		return state.leads.types.data
			.filter(
				(contactType) =>
					contactType.desc !== 'Title Company' || contactType.id !== 4,
			)
			.map((contactType) => ({
				name: contactType.desc,
				value: contactType.id,
				id: contactType.id,
			}));
	},
	// Used by BB email filter and CCContacts filters
	contactFilterOptions(state) {
		let data = state.leads.types.data;
		if (data.length > 0) {
			data = data.filter(
				(contactType) =>
					contactType.desc !== 'Title Company' || contactType.id !== 4,
			);
		}
		return {
			type: state.leads.types.type,
			data,
		};
	},
	loanTypeFilterOptions(state) {
		let data = state.loans.filterOptions.loanTypes;
		if (data.length > 0) {
			data = data.map((loanType) => {
				return {
					desc: loanType.typeDesc,
					id: loanType.typeId,
				};
			});
		}
		return {
			type: 'Loan Type',
			data,
		};
	},
	loanPurposeFilterOptions(state) {
		let data = state.loans.filterOptions.loanPurposeTypes;
		if (data.length > 0) {
			data = data.map((loanPurposeType) => {
				return {
					desc: loanPurposeType.purposeDesc,
					id: loanPurposeType.purposeId,
				};
			});
		}
		return {
			type: 'Loan Purpose',
			data,
		};
	},
	allContactFilters(state, getters) {
		return [
			getters.contactFilterOptions,
			getters.loanTypeFilterOptions,
			getters.loanPurposeFilterOptions,
		];
	},
	noFiltersSet(state, getters, rootState) {
		return (
			state.filters.typesIds.length === 0 &&
			state.filters.loanTypeIds.length === 0 &&
			state.filters.loanPurposeIds.length === 0 &&
			state.filters.searchTerm === '' &&
			rootState.clientConnectV2.selectedContactsIds.length === 0
		);
	},
	noLeadsFound(state, getters) {
		return state.leads.totalCount === 0 && getters.noFiltersSet;
	},
	noSearchResultsFound(state, getters) {
		return state.leads.totalCount === 0 && !getters.noFiltersSet;
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
};
